export enum CustomerStatus {
  Cooldown = 'Cooldown',
  RegularCustomer = 'RegularCustomer',
}
